(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template-annual-run"]) return;
  try {
    
$(document).ready(function(){
  function getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    
    return {
      total,
      days,
      hours,
      minutes,
      seconds
    };
  }
  
  function initializeClock(id, endtime) {
    const clock = document.getElementById(id);
    const daysSpan = clock.querySelector('.days');
    const hoursSpan = clock.querySelector('.hours');
    const minutesSpan = clock.querySelector('.minutes');
  
    function updateClock() {
      const t = getTimeRemaining(endtime);
  
      daysSpan.innerHTML = ('0' + t.days).slice(-2);
      hoursSpan.innerHTML = ('0' + t.hours).slice(-2); 
      minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
  
      if (t.total <= 0) {
        clearInterval(timeinterval);
      }
    }
  
    updateClock();
    const timeinterval = setInterval(updateClock, 1000);
  }
  
  const deadline = new Date(Date.parse('2022-11-24T16:00:00'));
  initializeClock('clockdiv', deadline);  
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-corp-order"] && !Shopify.designMode) return;
  try {
    

    $('.single-option-selector').change( function() {
        $( this ).parents( '.select-wrapper' )
        .find( '.selected-option' )
        .text( $("option:selected", this).text() );
    } ).change();

    $('#corp-contact-us').submit( function( event ) {
        event.preventDefault();
        var $form = $('#corp-contact-us')
        jQuery.ajax({
            type: 'POST',
            async: true,
            url: '/contact#corp-contact-us',
            data: $form.serialize(),
            error: function(response) { 
                console.log( response );
            },
            success: function(response) {
              $('#form-unsubmitted').toggle();
              $('#form-success').toggle();
              $('#corp-contact-us').toggle(); 
            }
        });         
    } );
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-partnerships"] && !Shopify.designMode) return;
  try {
    

    $('.single-option-selector').change( function() {
        $( this ).parents( '.select-wrapper' )
        .find( '.selected-option' )
        .text( $("option:selected", this).text() );
    } ).change();

    $('#corp-contact-us').submit( function( event ) {
        event.preventDefault();
        var $form = $('#corp-contact-us')
        jQuery.ajax({
            type: 'POST',
            async: true,
            url: '/contact#corp-contact-us',
            data: $form.serialize(),
            error: function(response) { 
                console.log( response );
            },
            success: function(response) {
              $('#form-unsubmitted').toggle();
              $('#form-success').toggle();
              $('#corp-contact-us').toggle(); 
            }
        });         
    } );
 

  } catch(e) { console.error(e); }
})();
})();
